import { useMemo } from "react";

interface FontAwesomeIconProps {
  iconName?: string;
}

export default function FontAwesomeIcon({ iconName }: FontAwesomeIconProps) {
  const ensuredIconName = useMemo(() => {
    if (!iconName) {
      return null;
    }
    if (!iconName?.startsWith("fa ")) {
      return `fa fa-${iconName}`;
    }
    return iconName;
  }, [iconName]);

  if (!ensuredIconName) {
    return null;
  }

  return <i className={ensuredIconName} aria-hidden={true} />;
}
